import { Component, ComponentInterface, h, Prop, Watch } from '@stencil/core';

export interface UiCmsFootnoteListBody {
  isIndexDisplayed?: boolean;
  startingIndex?: number;
  footnotes: Footnote[];
}

interface Footnote {
  text: string;
}

@Component({
  tag: 'ui-cms-footnote-list',
  styleUrl: 'ui-cms-footnote-list.scss',
})
export class UiCmsFootnoteList implements ComponentInterface {
  @Prop({ mutable: true }) body: UiCmsFootnoteListBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Prop() variant: string;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
  }

  render() {
    const { footnotes, startingIndex, isIndexDisplayed } = this.body;

    return (
      <ol class={this.variant ? `ui-cms-footnote--${this.variant}` : null}>
        {footnotes?.map((footnote, idx) => (
          <li key={idx}>
            <div>
              {isIndexDisplayed && <sup class="indent">{startingIndex + idx}</sup>}
              {footnote.text}
            </div>
          </li>
        ))}
      </ol>
    );
  }
}
